export default __webpack_public_path__ + "3893a14775882fb9ceee15556acd967b.png";